export class VolumeSettings {
    'type';
    'sizeBytes';
    'iops';
    'throughput';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": ""
        },
        {
            "name": "throughput",
            "baseName": "throughput",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VolumeSettings.attributeTypeMap;
    }
    constructor() {
    }
}
